import { Button } from '@eye-able/ui';
import LanguageSelect from '@components/LanguageSelect';
import NotificationSection from '@layout/Header/NotificationSection';
import { IconAccessible, IconLogout } from '@tabler/icons-react';
import ProfileSection from './ProfileSection';
import { demoModeAtom } from '@/global-store';
import useLogoutFn from '@/hooks/useLogoutFn.jsx';
import { useAtom } from 'jotai';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

const ICON_SIZE = '1.38rem';

function HeaderActions() {
  const { t, ts } = useInlineTranslation();
  const [demoMode] = useAtom(demoModeAtom);
  const logoutFn = useLogoutFn();

  return (
    <nav id='header-right-section' aria-label={ts('topNavAria')}>
      <ul className='eye:flex eye:gap-4xs eye:max-xl:p-2xs'>
        <li>
          <Button
            type='button'
            variant='ghost'
            id='eyeAble_customToolOpenerID'
            onClick={openAssistDefault}
          >
            <IconAccessible size={ICON_SIZE} />
            <span className='eye:max-xl:sr-only'>{t('accessibility')}</span>
          </Button>
        </li>
        <li>
          <LanguageSelect />
        </li>
        <li>
          <NotificationSection />
        </li>
        <li>
          {demoMode ? (
            <Button
              type='button'
              variant='ghost'
              onClick={() => {
                void logoutFn();
              }}
            >
              <IconLogout size={ICON_SIZE} />
              <span className='eye:max-xl:sr-only'>{t('exit')}</span>
            </Button>
          ) : (
            <ProfileSection />
          )}
        </li>
      </ul>
    </nav>
  );
}

function openAssistDefault() {
  try {
    window.EyeAbleAPI?.toggleToolbar();
  } catch (e) {
    console.log(e);
  }
}

export default HeaderActions;
